module.exports = __webpack_public_path__ + "img/bcard_3.58f81f9b.png";